import { render, staticRenderFns } from "./TopJettonItemSkeleton.vue?vue&type=template&id=cc811c92"
import script from "./TopJettonItemSkeleton.vue?vue&type=script&lang=js"
export * from "./TopJettonItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TopJettonItemSkeleton.vue?vue&type=style&index=0&id=cc811c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports